var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('video-header',[_vm._v("视频播放")]),_c('iframe',{attrs:{"src":_vm.url,"frameborder":"0","width":"100%"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }